import React from "react";
import {usePreviewContext} from "../../../context/PreviewContext";
import CCOCard from "../../fundamentals/CCOCard";
import {metaDataElementWithId} from "../../preview/previewMetaData";
import TeaserCardContent from "../C020TeaserCarousel/TeaserCardContent";
import {CallToActionType} from "../C020TeaserCarousel/TeaserCardCallToAction";

interface Props {
    item: any
    horizontal?: boolean
    headlineType?: string
    descriptionCharLimit?: number
    showHorizontalPictureOnRight?: boolean
}

function C078ViewTypeImageTextCard(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    const callToActionType = getCallToActionType(props);
    const noLink = !props.item.teaserTarget;
    return props.item &&
        <CCOCard dataCypress={'imageTextCard'}
                 item={props.item}
                 noLink={noLink}
                 padding={0}
                 hasFocusedStyle {...metaDataElementWithId(isPreview, props.item.id)}>
            {renderCardContent(props, callToActionType)}
        </CCOCard>
}

function renderCardContent(props: Props, callToActionType: CallToActionType | undefined) {
    return <TeaserCardContent item={props.item}
                              horizontal={props.horizontal}
                              headlineType={props.headlineType}
                              descriptionCharLimit={props.descriptionCharLimit}
                              callToActionType={callToActionType}
                              callToActionCustomText={props.item?.carouselSettings?.callToActionCustomText}
                              showHorizontalPictureOnRight={props.showHorizontalPictureOnRight}
    />
}

function getCallToActionType(props: Props) {
    if (!props.item.teaserTarget) {
        return undefined;
    }
    if (props.item?.carouselSettings?.callToActionEnabled === true) {
        return CallToActionType.BUTTON;
    }
    return CallToActionType.TEXT;
}

export default C078ViewTypeImageTextCard;